<template>
    <transition name="fade" mode="out-in">
        <div class="base-card">
            <slot />
        </div>
    </transition>
</template>
